import type { Reducer } from 'redux'
import { reduxRequestOriginMap } from '@/legacy/redux/constants'
import { Redux } from '@/legacy/redux'
import { checkRequestOrigin, setGenericField } from '@/legacy/redux/utils'
import type {
  SubjectsDrawerAction,
  SubjectsDrawerState,
} from '@/sections/principal/management/types/subjectsDrawer'
import {
  LIST_SUBJECTS_AS_PRINCIPAL_FAILURE,
  LIST_SUBJECTS_AS_PRINCIPAL_REQUEST,
  LIST_SUBJECTS_AS_PRINCIPAL_SUCCESS,
} from '@/legacy/redux/types/subjects'

const initialState: SubjectsDrawerState = {
  subjects: [],
  loading: false,
  pagination: {
    page: 0,
    rowsPerPage: 12,
    count: 0,
  },
  error: '',
  search: '',
}

const requestDestination = reduxRequestOriginMap.PRINCIPAL_SUBJECTS_DRAWER

const PrincipalSubjectsDrawerReducer: Reducer<SubjectsDrawerState, SubjectsDrawerAction> = (
  state = initialState,
  action
): SubjectsDrawerState => {
  switch (action.type) {
    case Redux.Types.Generic.SET_FIELD:
      return {
        ...setGenericField(state, action.payload),
      }
    case Redux.Types.Generic.CLEAR_STATE:
      return initialState
    case LIST_SUBJECTS_AS_PRINCIPAL_REQUEST:
      return {
        ...state,
        loading: true,
        pagination: {
          ...state.pagination,
          page: action.payload.page,
          rowsPerPage: action.payload.rowsPerPage,
        },
      }
    case LIST_SUBJECTS_AS_PRINCIPAL_SUCCESS:
      return {
        ...state,
        loading: false,
        subjects: action.payload.subjects,
        pagination: {
          ...state.pagination,
          count: action.payload.count,
        },
      }
    case LIST_SUBJECTS_AS_PRINCIPAL_FAILURE:
      return { ...state, loading: false, error: action.payload.error }
    default:
      return state
  }
}

export default checkRequestOrigin(initialState, PrincipalSubjectsDrawerReducer, requestDestination)
